const getCollectionByVendor=async()=>{
const container = document.querySelector('.artists-info[data-handle]');
const collectionHandle = container.dataset.handle;
const resq=await getCollectionByVendorQuery(collectionHandle);
console.log(resq.collection)
const artist_desc=document.querySelector(".artist-desc")
artist_desc.innerText=resq.collection.metafields[7].value

const artist_exhibition=document.querySelector(".exhibition_info")
artist_exhibition.innerHTML="<pre id='ex_info'>"+resq.collection.metafields[5].value+"</pre>";
}

getCollectionByVendor();

// 获取商品信息的函数
async function getCollectionByVendorQuery(handle) {
  const query = `
            query GetCollectionByHandle($handle: String!) {
        collection(handle: $handle) {
            id
            title
            handle
            description
            image {
            url
            altText
            }
            metafields(identifiers: [
                                        { namespace: "custom", key: "vendor_name" },
                                        { namespace: "custom", key: "type" },
                                        { namespace: "custom", key: "vendor_avatar_img" },
                                        { namespace: "custom", key: "vendor_main_img" },
                                        { namespace: "custom", key: "vendor_banner_img" },
                                        { namespace: "custom", key: "vendor_exhibitions" },
                                        { namespace: "custom", key: "vendor_biography" },
                                        { namespace: "custom", key: "vendor_desc" }
            ]) {
            id
            namespace
            key
            value
            type
            }
        }
        }
            `;

  const variables = {
    handle: handle,
  };

  return fetchGraphQL(query, variables)
    .then((data) => {
      console.log(data);
      // const product = data.productByHandle;
      // console.log(product);
      return data;
    })
    .catch((error) => {
      console.error("Error retrieving product:", error);
    });
}
function fetchGraphQL(query, variables = {}) {
  const endpoint =
    "https://store.magnifissance.com/api/2023-07/graphql.json";
  const accessToken = "6dd485b7997c77cc4794f50f5ff2ae3b"; // 替换为您的访问令牌

  return fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": accessToken,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  })
    .then((response) => response.json())
    .then((data) => data.data)
    .catch((error) => {
      console.error("GraphQL Error:", error);
    });
}